import { Typography } from '@mui/material';
import type { Currency, FixedProductInput } from '@weft/types';
import { isEmptyArray } from '@weft/utils';
import React from 'react';
import { AddIcon } from '../../../../../../components/icons/AddIcon';
import { AddItemMenuButton } from '../../../../../plans/CreatePlanPage/create-plan-page-components/CreatePlanPageTabs/create-plan-page-tabs-components/AddItemMenuButton';
import { EmptyTab } from '../../../../../plans/CreatePlanPage/create-plan-page-components/CreatePlanPageTabs/create-plan-page-tabs-components/EmptyTab';
import { FixedChargesEditTable } from '../../../../../plans/CreatePlanPage/create-plan-page-components/FixedChargesEditTable/FixedChargesEditTable';
import { CreateInvoicePageFixedChargesMenuItems } from './CreateInvoicePageFixedChargesMenuItems';

type CreateInvoicePageFixedChargesTabContentProps = {
  fixedProducts: FixedProductInput[];
  currency: Currency;
};

export const CreateInvoicePageFixedChargesTabContent: React.FC<CreateInvoicePageFixedChargesTabContentProps> = ({ fixedProducts }) => {
  if (isEmptyArray(fixedProducts)) {
    return (
      <EmptyTab
        title="Create and Add Fixed Fees"
        description="Set up one-time fees, subscription charges or price per unit to tailor your pricing model."
      >
        <AddItemMenuButton
          cta={
            <span className="flex items-center gap-x-2">
              <AddIcon fill="white"/>
              <span>Add Fees</span>
            </span>
          }
        >
          <CreateInvoicePageFixedChargesMenuItems/>
        </AddItemMenuButton>
      </EmptyTab>
    );
  }

  return (
    <div className="flex w-full flex-col gap-y-4">
      <div className="flex items-center justify-between">
        <Typography className="text-base font-medium">Service Fees</Typography>

        <AddItemMenuButton
          className="bg-[#EAEEFC] text-[#458FFF]"
          cta={<span className="flex items-center gap-x-2">
            <AddIcon/>
            <span>Add Item</span>
          </span>}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <CreateInvoicePageFixedChargesMenuItems/>
        </AddItemMenuButton>
      </div>

      <FixedChargesEditTable fixedProducts={fixedProducts}/>
    </div>
  );
};